import axiosClient from "./axiosClient";

// API cấu hình URL video hướng dẫn "mua sắm hoàn tiền" (Shopee/Lazada/TikTok).
// App & web đọc file tĩnh /img/guide-videos.json; admin sửa qua endpoint này.
const guideVideoApi = {
    getConfig() {
        return axiosClient.get("guide-video");
    },
    updateConfig(videos) {
        return axiosClient.put("guide-video", { videos });
    },
};

export default guideVideoApi;
